export const voicePreviewTemplates: Record<string, Record<string, string>> = {
  '*': {
    notSpecified: 'Hi, my name is {{ name }}. I am an English voice from the {{ country }}.'
  },
  en: {
    notSpecified: 'Hi, my name is {{ name }}. I am an English voice from the {{ country }}.'
  },
  'en-AU': {
    notSpecified: 'Hi, my name is {{ name }}. I am a British voice from Australia.'
  },
  ar: {
    notSpecified: 'Marhaba, ismy {{ name }}. souty bil-lougha {{ language }} al {{ country }}.'
  },
  bg: {
    notSpecified: 'Здравейте, казвам се {{ name }}. Аз съм от {{ country }}.'
  },
  da: {
    notSpecified: 'Hej, jeg hedder {{ name }}. Jeg er en dansk stemme.'
  },
  de: {
    notSpecified: 'Hallo, mein Name ist {{ name }}. Ich bin eine {{ language }} Stimme.'
  },
  es: {
    notSpecified: 'Hola, Soy {{ name }}! Soy una voz española de {{ country }}.'
  },
  fil: {
    notSpecified: 'Kamusta! Ako si {name}. Tinutulungan ako ng Speechify na magbasa nang mas mabilis.'
  },
  fr: {
    notSpecified: "Bonjour, je m'appelle {{ name }}. Je suis un voix {{ language }} provenant de {{ country }}."
  },
  hi: {
    notSpecified: 'नमस्ते, मेरा नाम {{ name }} है। मैं एक {{ language }} की आवाज हूं।'
  },
  te: {
    notSpecified: 'హాయ్ నా పేరు నరేంద్ర, నేను తెలుగు వాణిని'
  },
  it: {
    notSpecified: 'Hej, jeg hedder {{ name }}. Jeg er en italiensk stemme.'
  },
  nb: {
    notSpecified: 'Hei, jeg heter {{ name }}. Jeg er en svensk stemme.'
  },
  nl: {
    notSpecified: 'Hi, mijn naam is {{ name }}. Ik ben een {{ country }} {{ language }} stem.'
  },
  pl: {
    notSpecified: 'Cześć, nazywam się {{ name }}. Jestem polskim głosem.'
  },
  pt: {
    notSpecified: 'Olá, meu nome é {{ name }}. Eu sou uma voz portuguesa.'
  },
  ru: {
    notSpecified: 'Привет, меня зовут {{ name }}. Я говорю на русском языке.'
  },
  sv: {
    notSpecified: 'Hej, jag heter {{ name }}. Jag är en svensk röst.'
  },
  tr: {
    notSpecified: 'Merhaba, benim adım {{ name }}. Ben isveç sesim.'
  },
  uk: {
    notSpecified: 'Привіт, мене звати {{ name }}. Я голос з {{ country }}.'
  },
  zh: {
    notSpecified: '您好，我是 {{ name }}。我是 {{ country }} {{ language }} 的声音。'
  }
};
